import { PMH2_ROUTE_PATH } from './components/pmh2/routes'

// temples-around-world is a full-viewport fixed takeover (its own panels stack
// from z-index 200 up) - the global header underneath it was already invisible,
// and hiding it for real lets the floating ExperienceNavControls use their
// always-on-top treatment instead of the below-header one the takeover buries.
const routesWithoutGlobalChrome = [
  '/capstone-display',
  '/saltlakecitytemple/temples-around-world',
  '/saltlakecitytemple/where-work-done',
]
// /personalvideo re-runs the onboarding steps on the station and shares
// their sticky mobile Back/Next bar, which only stays pinned while the flow is
// the last thing on the page - the same reason /onboarding is listed.
// picturemyheritage (pmh2) is a full-viewport experience: its catalog is min-height 100vh over a
// fixed background, and choosing a Portrait opens a position:fixed capture overlay above
// everything. A global footer below that is only reachable by scrolling past a screen that is not
// meant to scroll.
// /recordstable sizes its surface from useAvailableViewportHeightCss(), which
// subtracts the header only - a footer below it makes the page taller than the
// viewport and scrolls by exactly the footer's height while the table itself is
// overflow: hidden.
const routesWithoutGlobalFooter = [
  '/myname',
  '/myyear',
  '/mytimemachine',
  '/heritage',
  '/onboarding',
  '/personalvideo',
  PMH2_ROUTE_PATH,
  '/recordstable',
  ...routesWithoutGlobalChrome,
]
const activityRoutesWithMobileHeaderHidden = ['/myname', '/myyear']
// The capstone wall has no input devices, so a feedback tab there is dead
// chrome painted over the artwork. Kept separate from routesWithoutGlobalChrome:
// the temple takeover hides header and footer but still wants feedback.
const routesWithoutFeedbackWidget = ['/capstone-display']

export const ACTIVITY_GLOBAL_HEADER_MAX_WIDTH = 1079.98
export const MOBILE_ACTIVITY_HEADER_MEDIA_QUERY = `(max-width: ${ACTIVITY_GLOBAL_HEADER_MAX_WIDTH}px)`

export const matchesRoutePrefix = (pathname, routePath, options = {}) => {
  const currentPathname = pathname ?? ''
  const currentRoutePath = routePath ?? ''
  const { includeExact = true } = options

  return (
    Boolean(currentRoutePath) &&
    ((includeExact && currentPathname === currentRoutePath) || currentPathname.startsWith(`${currentRoutePath}/`))
  )
}

const matchesAnyRoutePrefix = (pathname, routePaths, options) => {
  return routePaths.some((routePath) => matchesRoutePrefix(pathname, routePath, options))
}

export const shouldHideGlobalFooter = (pathname = '') => {
  return matchesAnyRoutePrefix(pathname, routesWithoutGlobalFooter)
}

export const shouldHideGlobalHeader = (pathname = '') => {
  return matchesAnyRoutePrefix(pathname, routesWithoutGlobalChrome)
}

export const shouldHideGlobalHeaderOnMobile = (pathname = '') => {
  return matchesAnyRoutePrefix(pathname, activityRoutesWithMobileHeaderHidden, { includeExact: false })
}

export const shouldHideFeedbackWidget = (pathname = '') => {
  return matchesAnyRoutePrefix(pathname, routesWithoutFeedbackWidget)
}
